<template>
    <svg :width="size" :height="size" :viewBox="`0 0 30 30`" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 2L28 28" :stroke="color" stroke-width="3" stroke-linecap="round" />
        <path d="M28 2.00708L2 28.0071" :stroke="color" stroke-width="3" stroke-linecap="round" />
    </svg>
</template>

<script>
    export default {
        props: {
            size: {
                type: Number,
                default: 30
            },
            color: {
                type: String,
                default: '#002677'
            }
        }
    }
</script>
